import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import Youtube from 'react-youtube';

class OverviewMedia extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mediaSource: null,
			imageFlag: true
		};
	}

	selectedImageMedia(image) {
		this.setState({
			mediaSource: image,
			imageFlag: true
		});
	}

	selectedVideoMedia(image) {
		this.setState({
			mediaSource: image,
			imageFlag: false
		});
	}

	render() {
		const productOverview = this.props.overView;
		let productMedia;
		let imageVideo;

		const mediaList = this.props.overView.media;
		const mediaSource = this.state.mediaSource === null ?
			mediaList[0].imageName : this.state.mediaSource;

		if (this.state.imageFlag) {
			imageVideo = (
				<img
					src={ mediaSource }
					alt="Model"
					itemProp="image"
				/>
			);
		} else {
			imageVideo = (
				<div className="embed-responsive-16x9">
					<Youtube
						videoId={ mediaSource }
						opts={{
							playerVars: {
								autoplay: 1,
								rel: 0
							}
						}}
					/>
				</div>
			);
		}

		if (mediaList !== null) {
			productMedia = (
				mediaList.map(image => { // eslint-disable-line array-callback-return
					if (image.imageName !== undefined) {
						return (
							<li
								className={
									image.thumbnailImage === mediaSource ? 'active' : ''
								}
								key={ image.imageName }
								onClick={ () => this.selectedImageMedia(image.imageName) }
							>
								<img
									src={ image.thumbnailImage }
									alt="thumbnail"
									className="thumbnail"
								/>
							</li>
						);
					} else if (image.youTubeId !== undefined) {
						return (
							<li
								className={ this.state.imageFlag ? '' : 'active' }
								key={ image.youTubeId }
								onClick={ () => this.selectedVideoMedia(image.youTubeId) }
							>
								<img
									src={ `//img.youtube.com/vi/${image.youTubeId}/1.jpg` }
									alt="thumbnail"
									className="thumbnail thumbnail-yt"
								/>
								<span className="fa fa-play" aria-hidden="true" />
							</li>
						);
					}
				})
			);
		}

		let securityProtection;
		let fireProtection;
		let waterProtection;

		if (productOverview.securityProtection) {
			securityProtection = (
				<li className="protection">
					<img
						className="icon"
						src={ require('../../resources/img/icons/security-icon.png') }
						srcSet={ `${require('../../resources/img/icons/security-icon@2x.png')} 2x` }
						alt="Security Protection"
					/> Security Protection
				</li>
			);
		}

		if (productOverview.fireProtection) {
			fireProtection = (
				<li className="protection">
					<img
						className="icon"
						src={ require('../../resources/img/icons/fire-icon.png') }
						srcSet={ `${require('../../resources/img/icons/fire-icon@2x.png')} 2x` }
						alt="Fire Resistant"
					/> Fire Protection
				</li>
			);
		}

		if (productOverview.waterProtection) {
			waterProtection = (
				<li className="protection">
					<img
						className="icon"
						src={ require('../../resources/img/icons/water-icon.png') }
						srcSet={ `${require('../../resources/img/icons/water-icon@2x.png')} 2x` }
						alt="Water Resistant"
					/> Water Protection
				</li>
			);
		}

		return (
			<div>
				<div className="col sm-6 image pt-4">
					{ imageVideo }
					<ul className="list-protection list-unstyled">
						{ securityProtection }
						{ fireProtection }
						{ waterProtection }

					</ul>
				</div>
				<div className="col sm-2 thumbs">
					<ul>
						{ productMedia }
					</ul>
				</div>
			</div>
		);
	}
}

export default branch({
	overView: ['product', 'overView']
}, OverviewMedia);


// WEBPACK FOOTER //
// ./src/pages/product/OverviewMedia.js